import {Component, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {FormControl, FormGroup} from "@angular/forms";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {MotifNonConformiteDTO} from "../../../core/dtos/motif-non-conformite-dto";
import {MotifsNonConformiteService} from "../../../core/services/entities/motifs-non-conformite.service";
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-motifNonConformiteDialog',
    templateUrl: './motif-non-conformite-dialog.component.html',
    styleUrls: ['./motif-non-conformite-dialog.component.scss'],
    standalone: false
})
export class MotifNonConformiteDialogComponent implements OnInit {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  subOpenDialog: Subscription

  motifNonConformite: MotifNonConformiteDTO;

  form: FormGroup = new FormGroup({});

  dialogTitle: String = 'Modification d\'un motif de non conformité';

  sitePlaceholder: String = 'Selectionner le site...';

  displayDialog = false;

  idSelectedSite: number;

  constructor(private auth2Svc: Auth2Service,
              private toastSvc: ToastService,
              public motifsNonConformiteSvc: MotifsNonConformiteService,
              public utilsSvc: UtilsService) {
  }

  ngOnInit() {
    this.initForm();
    this.openDialogEditionSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
  }

  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.motifsNonConformiteSvc.openDialogEdition$
      .subscribe((cdt: MotifNonConformiteDTO) => {
        this.displayDialog = true;
        if (!cdt) {
          this.motifNonConformite = new MotifNonConformiteDTO();
          this.motifNonConformite.id = 0;
          this.dialogTitle = 'Création d\'un motif de non conformité';
        } else {
          this.motifNonConformite = cdt;
          this.dialogTitle = 'Modification d\'un motif de non conformité';
        }
        this.initForm();
      });
  };

  findAllLocalSites = (): SiteDTO[] => {
    return this.auth2Svc.utilisateur.siteListLocaux;
  }

  closeDialog = (): void => {
    this.displayDialog = false;
  };

  save = (): void => {
    if (this.form.valid) {
      let newMotifNonConformite: MotifNonConformiteDTO = {...this.motifNonConformite};
      newMotifNonConformite.site = {id: this.idSelectedSite} as SiteDTO;
      newMotifNonConformite.libelle = this.form.controls['libelle'].value;
      newMotifNonConformite.actif = this.form.controls['actif'].value;
      this.motifsNonConformiteSvc.save(newMotifNonConformite)
        .subscribe(response => {
          const isUpdate = newMotifNonConformite.id !== null && newMotifNonConformite.id !== undefined && newMotifNonConformite.id !== 0;
          this.motifsNonConformiteSvc.announceMotifNonConformiteSaved(response.one, isUpdate);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde du motif de non conformite réalisée avec succès`);
          this.closeDialog();
        });
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  };

  initForm = (): void => {
    this.sitePlaceholder = !this.canModify() ? this.motifNonConformite?.site?.libelle : 'Selectionner le site...';
    this.idSelectedSite = this.motifNonConformite?.site?.id;
    this.form = new FormGroup({
      libelle: new FormControl(this.motifNonConformite?.libelle),
      actif: new FormControl(this.motifNonConformite?.actif != null ? this.motifNonConformite.actif : true)
    });
  };

  onChangeSite = ($event: any): void => {
    this.idSelectedSite = $event.selectedItem?.id;
  }

  canModify = () => {
    return this.motifsNonConformiteSvc.canModify(this.motifNonConformite);
  }

}

